const LAST_APP_ROUTE_KEY = 'escalador.last-app-route'

const nonRestorablePaths = ['/', '/selecaoEmpresa', '/gerencial']

export function isRestorableAppRoute(path) {
	const normalizedPath = String(path || '').split('?')[0]
	if (!normalizedPath || nonRestorablePaths.includes(normalizedPath)) return false
	return !normalizedPath.startsWith('/portal/')
}

export function saveLastAppRoute(route) {
	if (typeof sessionStorage === 'undefined' || !route || !isRestorableAppRoute(route.path)) return
	const fullPath = route.fullPath || route.path
	if (fullPath) sessionStorage.setItem(LAST_APP_ROUTE_KEY, fullPath)
}

export function getLastAppRoute() {
	if (typeof sessionStorage === 'undefined') return null
	const route = sessionStorage.getItem(LAST_APP_ROUTE_KEY)
	return isRestorableAppRoute(route) ? route : null
}

export function clearLastAppRoute() {
	if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(LAST_APP_ROUTE_KEY)
}

